import React from "react";
import Menu from "./Menu";
import { Button, Box } from "@mui/material";

// ** MUI
import {Backdrop, CircularProgress} from '@mui/material';

// ** Data
import { initialDestinations } from "../data";
import { DestinationOption } from "../dataTypes";

// Zustand
import { useResortMenuStore } from "../store/resortMenuStore";
import ResortBodySection from "./ResortBody";

// ** Services
import ResortService from "../service/ResortService";

// ** Tanstack
import {
  useQuery,
  useInfiniteQuery,
} from "@tanstack/react-query";
import { KEYS } from "../constants/keys";
import { ACF_FIELDS } from "../constants/acf-fields";

export type ResortItem = {
  id : number
  image : string
  link : string
  short_description : string
  title : string
}

export type RESTData = {
  current_page : string
  items : ResortItem[]
  total_pages : number
}

type ResortProps = {};

const Resorts = (props: ResortProps) => {

  // ** States
  const [ paginate, setPaginate ] = React.useState<number>(21)
  const [ page, setPage ] = React.useState<number>(1)
  const [ openBackDrop, setOpenBackDrop ] = React.useState<boolean>(false)

  const [resortItems, setResortItems] = React.useState<any | null>(null)
  
  const [destinations, setDestinations] = React.useState(initialDestinations);
  const selectedDestination = destinations.find(
    (item) => item.selected == true
  );

  // ** Zustand
  const {
    clearParams,
    setSelectedDestinationGlobal,
    closeMenuOpen,
    closeSubMenu,
    params,
  } = useResortMenuStore();

  const buildQueryForPHP = (filters : any[] ) => {
    const filterArray : {}[] = []
    const newFilter = filters.map( f => {

      let filterKey : any = Object.values(f)[0]
      let filterKeyValues = filterKey.flatMap( (item : any) => mapToACFFieldValues(item.value) ) 

      let obj = {
        key : mapToACFFields( Object.keys(f)[0] ), // the key string eg. size, room_type etc
        values : filterKeyValues
      }

      filterArray.push(obj)

    })

    console.log('filterArray',filterArray)

    return filterArray
  }

  const mapToACFFields = (str : string) => {
    switch( str ) {
      case ACF_FIELDS.LUXURY : 
        return ACF_FIELDS.LUXURY_QUALITY
      case ACF_FIELDS.RESORT_STYLE :
        return ACF_FIELDS.RESORT_OR_CAMP_STYLE
      case ACF_FIELDS.ROOM_TYPE : 
        return ACF_FIELDS.ROOM_TYPE
      case ACF_FIELDS.PRICE_RANGE :
          return ACF_FIELDS.PRICE_RANGE
      case ACF_FIELDS.TRIP : 
        return ACF_FIELDS.LENGTH_OF_TRIP
      default :
        return str
    }
  }

  const mapToACFFieldValues = (str : string) => {
    switch (str) {
      case '50 Or Less' :
        return '50 or less guest rooms'
      case '50 Or More' :
        return '50+ guest rooms'

      case 'Overwater Villa With Pool' :
        return 'Overwater villa with pool'
      case 'Villa with a pool':
        return 'Villa with pool'
      case 'Beach Villa' :
          return 'Beach villa'
      
      case 'Super Luxury' :
        return 'Super luxury'

      default : return str
    }
  }


  // ** Tanstack
  const { getResorts, getInfiniteResorts} = ResortService()

  const q = useInfiniteQuery<RESTData>({
    staleTime : Infinity,
    queryKey : [KEYS.RESORTS, page, selectedDestination, params],
    enabled : selectedDestination != undefined,
    getNextPageParam :  prevData => {
      if (Number(prevData.current_page) < Number(prevData.total_pages)) {
        return Number(prevData.current_page) + 1
      } else {
        return false
      }
      
    },
    queryFn : ({ pageParam = 1 }) => getInfiniteResorts({ 
      parameters : { 
      page : pageParam,
      destination : selectedDestination?.destination,
      posts_per_page : paginate,
      ...( params.length && params ? { filters : buildQueryForPHP(params) } : null  )
    }
    }),
    onSuccess : (response) => {

    },
    onError : () => {
     
    },
    onSettled : (response) => {
 
    }
  })



  const onDestinationIitemClick = (id: number) => {
    const newDestinations = destinations.map((item) => {
      if (item.selected == true) {
        item.selected = false;
      }
      return item;
    });
    const dest = newDestinations.find((item) => id == item.id);
    (dest as DestinationOption).selected = !dest?.selected;
    setSelectedDestinationGlobal((dest as DestinationOption).destination);

    setDestinations(newDestinations);

    //call zustand globalStore
    clearParams();
    closeMenuOpen();
    closeSubMenu();

    
  };

  const handleClose = () => {
    setOpenBackDrop(false);
  };
 
  
  return (
      <div>
        <Menu
          destinations={destinations}
          handleDestinationClick={onDestinationIitemClick}
          selectedDestination={selectedDestination!}
        />

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={ q.isFetching || q.isLoading ? true : false}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        { 
          q.data?.pages &&
          <ResortBodySection resortsData={q.data.pages.flatMap( item => item.items )} />
        }
        
        <div className="container-nearedge">
          <Box sx={{ 
                display:'flex',
                justifyContent: 'center',
                alignItems : 'center',
                marginBlock : '1rem'
              }}>
            {
              q.hasNextPage && 
              <Button 
              size='large'
              sx={{
                color : '#fff',
                backgroundColor : '#333',
                minWidth : '200px',
                padding: '1.5em 1.5em',
                mt : [5,5]
              }}
              variant='contained'
              onClick={ ()=>{ q.fetchNextPage() } }>More Resorts</Button>
            }
          </Box>
        </div>
        
        

      </div>
  );
};

export default Resorts;
